var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel-content",
    {
      attrs: {
        "hide-actions": !_vm.hasEventRecords,
        disabled: !_vm.hasEventRecords,
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "v-layout",
                [
                  _c("div", { staticClass: "subheading" }, [
                    _vm.log._source.IsTestRun
                      ? _c("span", { staticClass: "info--text" }, [
                          _vm._v("[TEST RUN]"),
                        ])
                      : _vm.log._source.IsCheckFileFormat
                      ? _c("span", { staticClass: "info--text" }, [
                          _vm._v("[VALIDATION]"),
                        ])
                      : _vm.log._source.IsRollback
                      ? _c("span", { staticClass: "error--text" }, [
                          _vm._v("[ROLLBACK]"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "grey--text text--lighten-1" }, [
                      _vm._v(
                        _vm._s(_vm.executionDate) +
                          " · " +
                          _vm._s(_vm.log._source.FileName) +
                          " -"
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.log._source.ExecutionOutcome) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mr-2 d-flex align-center" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: _vm.getInfoLogsColor(_vm.log) } },
                        [_vm._v("done")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "log-message-count" }, [
                        _vm._v(
                          _vm._s(_vm.infoFormatCount(_vm.getInfoCount(_vm.log)))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mr-2 d-flex align-center" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: _vm.getWarningLogsColor(_vm.log) } },
                        [_vm._v("warning")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "log-message-count" }, [
                        _vm._v(
                          _vm._s(_vm.formatCount(_vm.getWarnCount(_vm.log)))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mr-2 d-flex align-center" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: _vm.getErrorLogsColor(_vm.log) } },
                        [_vm._v("error")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "log-message-count" }, [
                        _vm._v(
                          _vm._s(_vm.formatCount(_vm.getErrorCount(_vm.log)))
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("InnerDetailDialog", {
                ref: "dialog",
                attrs: { detailedEvent: _vm.detailedEvent },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "VirtualList",
        { attrs: { size: 40, remain: 6 } },
        _vm._l(_vm.parsedEventRecords, function (eventRecord, j) {
          return _c(
            "v-card",
            { key: j },
            [
              _c(
                "v-expansion-panel-content",
                {
                  staticClass: "inner-event-log",
                  class: { stripe: j % 2 == 0 },
                  attrs: { disabled: !eventRecord.details },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            eventRecord.MaxLevel !== null
                              ? [
                                  eventRecord.MaxLevel ===
                                  _vm.logTypes.info.value
                                    ? _c(
                                        "div",
                                        { staticClass: "flex-grow-0 mr-2" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "light-green" } },
                                            [_vm._v("done")]
                                          ),
                                        ],
                                        1
                                      )
                                    : eventRecord.MaxLevel ===
                                      _vm.logTypes.warn.value
                                    ? _c(
                                        "div",
                                        { staticClass: "flex-grow-0 mr-2" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "yellow" } },
                                            [_vm._v("warning")]
                                          ),
                                        ],
                                        1
                                      )
                                    : eventRecord.MaxLevel ===
                                      _vm.logTypes.error.value
                                    ? _c(
                                        "div",
                                        { staticClass: "flex-grow-0 mr-2" },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v("error")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(eventRecord.Message[0])),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  eventRecord.details
                    ? _c("v-card", [
                        _c(
                          "table",
                          {
                            staticClass:
                              "inner-nested-event-log max-width text-xs-left",
                            class: { stripe: j % 2 == 0 },
                            attrs: { cellspacing: "10" },
                          },
                          [
                            _c("col", { attrs: { width: "10%" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "50%" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "20%" } }),
                            _vm._v(" "),
                            _c(
                              "tr",
                              [
                                _vm._l(
                                  Object.keys(eventRecord),
                                  function (key, k) {
                                    return [
                                      key != "color"
                                        ? _c("th", { key: k }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.splitByCapitalLetter(key)
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "tr",
                              { class: eventRecord.color[0] + "--text" },
                              [
                                _c("td", [
                                  _vm._v(_vm._s(eventRecord.EventLevel[0])),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(eventRecord.Message[0])),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            eventRecord.details &&
                            eventRecord.details.length > 0
                              ? _vm._l(
                                  eventRecord.details,
                                  function (record, l) {
                                    return _c(
                                      "tr",
                                      {
                                        key: l,
                                        class: record.color + "--text",
                                      },
                                      [
                                        _c("td", [
                                          _vm._v(_vm._s(record.EventLevel)),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(record.Message)),
                                        ]),
                                        _vm._v(" "),
                                        Object.keys(record).length > 3
                                          ? _c(
                                              "td",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      text: "",
                                                      light: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setDetailedEventRecord(
                                                          record,
                                                          _vm.log._source
                                                            .ProcessInstanceId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Button.ViewDetails"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("br"),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }